export default __webpack_public_path__ + "static/media/plus_light.e3eda261.svg";